import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StepTutorial } from 'src/app/models/shared/step-tutorial.model';

@Component({
	selector: 'cmv-steps-tutorial',
	templateUrl: './steps-tutorial.component.html',
	styleUrls: ['./steps-tutorial.component.scss'],
})
export class StepsTutorialComponent {
	@Input() steps: Array<StepTutorial>;
	currentStep: number = 1;

	@Output() finishTutorial: EventEmitter<void> = new EventEmitter();
	@Output() closeTutorial: EventEmitter<void> = new EventEmitter();

	constructor() {}

	get currentTutorialStep() {
		return this.steps.find(
			tutorialStep => tutorialStep.stepNumber === this.currentStep
		);
	}

	get isStepLastStep(): boolean {
		return this.currentStep === this.steps.length;
	}

	get isStepFirstStep(): boolean {
		return this.currentStep === 1;
	}

	onFinishTutorial(): void {
		this.finishTutorial.emit();
	}

	onNextStep(): void {
		if (this.currentStep < this.steps.length) {
			this.currentStep++;
		}
	}

	onPreviousStep(): void {
		if (this.currentStep > 1) {
			this.currentStep--;
		}
	}

	onCloseTutorial(): void {
		this.closeTutorial.emit();
	}
}
